// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3unD_","icon":"styles_icon__B20Nm"};